import axios from "axios"
import configData from "../appsettings.json"

export function addVenue(data, Idtoken) {
    return axios.post(`${configData.baseUrl}/SqlVenue/CreateVenue`, JSON.stringify(data), {
        headers : {
            'X-Firebase-Authorization' : Idtoken,
            'Content-Type': 'application/json',
            'Accept': 'application/json, text/plain, */*',
        }
    });
}

export async function getMyAccess(Idtoken) {
    return axios.get(`${configData.baseUrl}/SqlVenue/GetMyAccess`, {
        headers : {
            'X-Firebase-Authorization' : Idtoken,
            'Content-Type': 'application/json',
            'Accept': 'application/json, text/plain, */*',
        }
    });
}

export async function getAllVenues(Idtoken) {
    return axios.get(configData.baseUrl + '/SqlVenue/GetVenues', {
        headers : {
            'X-Firebase-Authorization' : Idtoken,
            'Content-Type': 'application/json',
            'Accept': 'application/json, text/plain, */*',
        }
        })
}

export function getVenueById(id, Idtoken) {
    return axios.get(`${configData.baseUrl}/SqlVenue/GetVenuesById?venueid=${id}`, {
        headers : {
            'X-Firebase-Authorization' : Idtoken,
            'Content-Type': 'application/json',
            'Accept': 'application/json, text/plain, */*',
        }
    });
}

export function updateVenue(data, Idtoken){
    return axios.put(`${configData.baseUrl}/SqlVenue/UpdateVenue`, JSON.stringify(data), {
        headers : {
            'X-Firebase-Authorization' : Idtoken,
            'Content-Type': 'application/json',
            'Accept': 'application/json, text/plain, */*',
        }
    });
}

export function deleteVenue(id, Idtoken){
    return axios.delete(`${configData.baseUrl}/SqlVenue/DeleteVenue?venueId=${id}`, {
        headers : {
            'X-Firebase-Authorization' : Idtoken,
            'Content-Type': 'application/json',
            'Accept': 'application/json, text/plain, */*',
        }
    });
}